import { Quadkey, XyoWorldGeotoken } from '@xyo-network/sdk-xyoworld-js'
import { createContext } from 'react'

interface GeotokenContext {
  geotoken?: XyoWorldGeotoken | null
  quadkey?: Quadkey
  refresh?: () => void
}

const Context = createContext<GeotokenContext>({})

export default Context
